import React from 'react';
import PropTypes from 'prop-types';

import './loading.css';

const Button = (props) => {
  const buttonColor = 'button-' + (props.color ? props.color : 'primary');
  return (
    <button
      id={props.id}
      className={
        props.classes
          ? `button ${buttonColor} ` + props.classes
          : `button ${buttonColor} `
      }
      onClick={props.onClick}
      disabled={props.loading || props.disabled}
      style={props.style}
      type={props.type}
    >
      {props.loading ? <div className="ld ld-ring ld-spin" /> : props.children}
    </button>
  );
};

export default Button;

Button.propTypes = {
  id: PropTypes.string,
  classes: PropTypes.string,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Button.defaultProps = {
  loading: false,
  color: 'primary',
  type: 'button',
};
